import React from "react";

export const ApprovedNoteSvg = () => {
  return (
    <div>
      <svg
        width="57"
        height="56"
        viewBox="0 0 57 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x=".5" width="56" height="56" rx="28" fill="#E6F6F4" />
        <path
          d="M36 29v-3c0-3.3 0-4.95-1.025-5.975S32.3 19 29 19h-3c-3.3 0-4.95 0-5.975 1.025S19 22.7 19 26v5c0 3.3 0 4.95 1.025 5.975S22.7 38 26 38h1.5m5-20v2m-5-2v2m-5-2v2M30 36s1 0 2 2c0 0 3.177-5 6-6m-14.5-1h4m-4-5h8"
          stroke="#039855"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
